import { ReactElement } from 'react'

import { updateAdAccounts } from 'api/Cerebro/orgScoped/amazonAdsApi'
import { useResource } from 'components/EditableFields/localHooks'
import { userHasManageLabelsPermissions } from 'helpers/featurePermissions'
import { useUserHasPermissions, useResourceOfPage } from 'hooks'
import { Label, ProfileFact } from 'types'

import { DeleteField } from '../../SharedFields/DeleteField'

interface Props<RecordType> {
    dataIndex: string[]
    readOnly: boolean
    record: RecordType
    reloadData: () => void
}

function RemoveFromLabelField<RecordType extends ProfileFact>({
    dataIndex = ['profile'],
    readOnly = false,
    record,
    reloadData,
}: Props<RecordType>): ReactElement {
    const hasLabelPermissions = useUserHasPermissions(
        userHasManageLabelsPermissions
    )

    const label: Label | null = useResourceOfPage('labelPage')

    const { getFromResource, resourceId } = useResource<RecordType>(
        record,
        dataIndex,
        'profile'
    )

    const getIsDisabled = (): boolean => {
        const userCanManageBrand = getFromResource(['user_can_manage'], true)
        return !hasLabelPermissions || !userCanManageBrand || readOnly
    }

    return (
        <DeleteField
            disabled={getIsDisabled()}
            okText="Remove"
            title={`Are you sure you want to remove this advertising account from ${label?.name}?`}
            updateRequestApi={updateAdAccounts}
            updateRequestCallback={reloadData}
            updateRequestData={{
                items: [{ id: resourceId, remove_label_ids: [label?.id] }],
            }}
            updateRequestSuccessMesg="Advertising account successfully removed"
        />
    )
}

export default RemoveFromLabelField
